import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { supabase } from "../lib/supabase";

// Global watcher for any ?code= OAuth responses that land on any route.
// Acts as a safety net in case the dedicated callback page doesn't run or navigate.
const OAuthWatcher = () => {
  const location = useLocation();
  const exchanging = useRef(false);
  const isCallbackRoute = location.pathname?.startsWith("/auth/callback");
  const isGoogleOAuthRoute = location.pathname?.startsWith("/provider/spreadsheet") ||
                              location.pathname?.startsWith("/provider/onboarding") ||
                              location.pathname?.startsWith("/provider/settings");
  const isAcceptInviteRoute = location.pathname?.startsWith("/accept-invite");

  useEffect(() => {
    if (isCallbackRoute || isGoogleOAuthRoute || isAcceptInviteRoute) return; // Dedicated handlers for these routes

    const params = new URLSearchParams(location.search);
    const code = params.get("code");
    // Only allow relative paths to prevent open redirect attacks
    const rawRedirect = params.get("redirect") || "/dashboard";
    const redirect = rawRedirect.startsWith("/") && !rawRedirect.startsWith("//") ? rawRedirect : "/dashboard";

    if (!code || exchanging.current) return;
    exchanging.current = true;

    const run = async () => {
      try {
        await supabase.auth.exchangeCodeForSession(window.location.href);
      } catch {
        window.location.replace("/login");
        return;
      }

      window.location.replace(redirect);
    };

    run();
  }, [location.search, isCallbackRoute]);

  return null;
};

export default OAuthWatcher;

